import { resolveReferencePath } from '@scalar/json-magic/bundle';
import { fetchUrls } from '@scalar/json-magic/bundle/plugins/browser';
import { shallowReactive } from 'vue';
/** Cache external payloads and in-flight requests without changing authored examples. */
export const createExternalExampleResolver = (options = {}) => {
    const loader = fetchUrls({ ...options, limit: 10 });
    const cache = new Map();
    return (example) => {
        if (example.value !== undefined || !example.externalValue) {
            return { status: 'loaded', value: example.value, load: () => Promise.resolve() };
        }
        const url = resolveReferencePath(options.origin ?? '', example.externalValue) ?? example.externalValue;
        const cached = cache.get(url);
        if (cached) {
            return cached;
        }
        let pending;
        const state = shallowReactive({
            status: 'idle',
            load: () => {
                if (pending) {
                    return pending;
                }
                if (state.status === 'loaded') {
                    return Promise.resolve();
                }
                state.status = 'loading';
                pending = (async () => {
                    try {
                        const selectedLoader = [loader, options.fileLoader].find((candidate) => candidate?.validate(url));
                        const result = await selectedLoader?.exec(url);
                        if (result?.ok) {
                            state.serializedValue = typeof result.raw === 'string' ? result.raw : undefined;
                            state.value = result.data === undefined ? result.raw : result.data;
                            state.status = 'loaded';
                        }
                        else {
                            state.status = 'error';
                        }
                    }
                    catch {
                        state.status = 'error';
                    }
                    finally {
                        pending = undefined;
                    }
                })();
                return pending;
            },
        });
        cache.set(url, state);
        return state;
    };
};
